import React from "react"
import axios from "axios"

// error message component
const ErrorMessage = ({ message }) => (
  <span className="absolute l-15 b--25 ff-open-sans ff-regular fdot8 c-error">
    {message}
  </span>
)

// error messages for different
// types of errors
const errorMessages = {
  required: "This field is required",
  email: "Please enter a valid email address",
}

// regex for validations
const pattern = {
  email:
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]){1,}?)+$/,
  name: /^[a-zA-Z]{4,}(?: [a-zA-Z]+)?(?: [a-zA-Z]+)?$/,
}

const getSessionToken = () => {
  const promise = axios.get(`${process.env.GATSBY_API_URL}session/token`)
  const dataPromise = promise.then(response => response.data)

  return dataPromise
}

const getAccessToken = () => {
  var bodyFormData = new FormData()
  bodyFormData.append("grant_type", "password")
  bodyFormData.append("client_id", "4b5bf88a-34cd-4a10-b4a1-7434f11c3532")
  bodyFormData.append("client_secret", "!Heritage_Resorts_2021!")
  bodyFormData.append("username", "restuser")
  bodyFormData.append("password", "[QZA2[L$b9?,h&zP")

  const promise = axios({
    method: "post",
    url: `${process.env.GATSBY_API_URL}oauth/token`,
    data: bodyFormData,
    headers: { "Content-Type": "multipart/form-data" },
  })

  const dataPromise = promise.then(response => response.data.access_token)

  return dataPromise
}

export { ErrorMessage, errorMessages, pattern, getAccessToken, getSessionToken }
